import { toggle } from "@otto-ec/global-resources/toggle";
import {
  scope as navigationScope,
  paramsMap,
  stateMap,
} from "@otto-ec/global-resources/navigation";
import type { Unset } from "@otto-ec/global-resources/nexus";
import type { Unsubscriber } from "svelte/store";
import type { SheetHistoryState, SheetNavScope } from "./scope.js";
import { initQueryParams } from "./fragment.js";
import { navScope } from "./scope.js";
import { prepareOpenSheetOnPageEntry } from "./pageEntry.js";
import { initHistoryHandling } from "./stack.svelte.js";
import { sheetTagName } from "../utils/consts.js";

/**
 *
 *
 *
 */

const useHistoryToggle = [
  "oc_sheet_v1_use_navigation_history",
  import.meta.env.STORYBOOK ?? false,
] as const;

const log = /*           */ navScope.scope("init");

/**
 *
 *
 *
 */
export function useGlobalNavigation(): Unsubscriber {
  if (import.meta.env.DEV) log.info("init global navigation integration");

  /*                                     */
  const unsubs: (Unset | Unsubscriber)[] = [];

  const initNavigation = async (): Promise<void> => {
    const sheetNavScope: SheetNavScope = await navigationScope(sheetTagName, {
      hash: paramsMap([sheetTagName]),
      state: stateMap<SheetHistoryState>(),
    });

    /*                                */
    if (toggle.get(...useHistoryToggle)) {
      await prepareOpenSheetOnPageEntry(sheetNavScope);
    } else if (import.meta.env.DEV)
      log.info("history updater integration is disabled by toggle:", useHistoryToggle[0]);

    /*                                                                   */
    unsubs.push(
      $effect.root(() => {
        if (toggle.get(...useHistoryToggle)) {
          initHistoryHandling(sheetNavScope);
        }
      }),
    );

    /*                                                                                 */
    unsubs.push(initQueryParams(sheetNavScope));
  };

  /*                             */
  /*                                          */
  initNavigation();
  return () => unsubs.forEach((u) => u());
}
